import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import {
    EmailInput,
    Form,
    PhoneInput,
    PrimaryButton,
    StringInput,
} from '@ratehub/base-ui';
import styled from 'styled-components';


function ConfirmationForm({
    firstName,
    lastName,
    phone,
    email,
    onSubmit,
}) {
    return (
        <StyledContainer className="rh-mx-auto">
            <h1 className="rh-title-m rh-m-0">
                <FormattedMessage
                    id="InsCommon.ConfirmationPageTemplate.ConfirmDetailsTitle"
                    defaultMessage="Please confirm your information if you would like to speak with a broker"
                />
            </h1>

            <StyledForm
                className="rh-display-grid rh-gap-1 rh-mt-1"
                onSubmit={onSubmit}
            >
                <StringInput
                    name="firstName"
                    value={firstName}
                    label={(
                        <FormattedMessage
                            id="InsCommon.ConfirmationPageTemplate.ConfirmationForm.firstName"
                            defaultMessage="First name"
                        />
                    )}
                />

                <StringInput
                    name="lastName"
                    value={lastName}
                    label={(
                        <FormattedMessage
                            id="InsCommon.ConfirmationPageTemplate.ConfirmationForm.lastName"
                            defaultMessage="Last name"
                        />
                    )}
                />

                <PhoneInput
                    name="phone"
                    value={phone}
                    label={(
                        <FormattedMessage
                            id="InsCommon.ConfirmationPageTemplate.ConfirmationForm.phone"
                            defaultMessage="Phone"
                        />
                    )}
                />

                <EmailInput
                    name="email"
                    value={email}
                    label={(
                        <FormattedMessage
                            id="InsCommon.ConfirmationPageTemplate.ConfirmationForm.email"
                            defaultMessage="Email"
                        />
                    )}
                />

                <PrimaryButton
                    className="submit-button"
                    type="submit"
                    message={(
                        <FormattedMessage
                            id="InsCommon.ConfirmationPageTemplate.ConfirmDetails.Submit"
                            defaultMessage="Submit"
                        />
                    )}
                    data-name="ConfirmationPage-continue"
                />
            </StyledForm>
        </StyledContainer>
    );
}

ConfirmationForm.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    onSubmit: PropTypes.func,
};

const StyledContainer = styled.div`
    max-width: 600px;
`;

const StyledForm = styled(Form)`
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

    > .submit-button {
        grid-column-start: -2;
    }
`;

export default observer(ConfirmationForm);